<template>
  <span :class="classes" @click="toggleMenu">
    <span></span>
    <span></span>
    <span></span>
  </span>
</template>

<script>
export default {
  name: 'AppMenuMobileButton',
  status: 'prototype',
  release: '1.0.0',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      lazyValue: false
    }
  },
  computed: {
    classes () {
      return {
        'mobile-button': 'mobile-button',
        'mobile-button--active': this.isOpen
      }
    },
    isOpen: {
      get () {
        return !!this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value (val) {
      this.lazyValue = val
    }
  },
  beforeMount () {
    window.addEventListener('resize', () => {
      this.isOpen = false
    })
  },
  methods: {
    toggleMenu () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
.mobile-button {
	position: relative;
	span {
		display: block;
		width: 33px;
		height: 4px;
		margin-bottom: 5px;
		position: relative;
		background-color: #cdcdcd;
		border-radius: 3px;
		z-index: 1;
		transform-origin: 4px 0px;
		transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
								opacity 0.55s ease;

		&:nth-child(1) {
			transform-origin: 0% 0%;
		}
		&:nth-child(3) {
			transform-origin: 0% 100%;
		}
	}
	&--active {
		span {
			opacity: 1;
			transform: rotate(45deg) translate(-2px, -1px);
			background-color: $color-ice;
			&:nth-child(2) {
				opacity: 0;
				transform: rotate(0deg) scale(0.2, 0.2);
			}
			&:nth-child(3) {
				transform: rotate(-45deg) translate(-2px, 1px);
			}
		}
	}
}
</style>
